"use client"
import React, { useState, useEffect, useRef } from "react";
import dynamic from 'next/dynamic';
const Header = dynamic(() => import('@/Component/Header'), { ssr: false });
const Footer = dynamic(() => import('@/Component/Footer'), { ssr: false });
const TitleText = dynamic(() => import('@/Component/TitleText'), { ssr: false });
import styles from "./PrivacyPolicyPage.module.css";


import { useTranslation } from "react-i18next";
import button_image from "@/assets/Icon/Down_Icon.png";
import Image from "next/image";
const PrivacyPollcyElement = ({ service_info }) => {
    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);

    const contentRef = useRef(null);
    const [height, setHeight] = useState(0);
    useEffect(() => {
        if (contentRef.current) {
            setHeight(contentRef.current.scrollHeight); // 실제 높이 구함
        }
    }, [isOpen]);

    const handleOpen = (isOpen) => {
        setIsOpen(isOpen);
    }
    return (
        <div className={`${styles.service__box} ${isOpen ? styles.open : ""}`}>
            <div className={styles.service__title} onClick={() => handleOpen(!isOpen)}>
                <span className={styles.title__text}>
                    {t(service_info.title_text_key)}
                </span>

                <div className={`${styles.lang__down__btn} ${isOpen? styles.open : ""}`}>
                    <Image src={button_image} className={`${styles.lang__down__btn__image}`} alt="button"/>

                </div>
            </div>
            < div className={`${styles.service__text} ${isOpen ? styles.open : ""}`} ref={contentRef}>
                <span className={`${styles.description__text}`} style={isOpen ? { maxHeight: `${height}px` } : {}} >
                    {t(service_info.description_text_key)}
                </span>
            </div>
        </div>
    );
}

const PrivacyPolicyPage = ({ elementData, title_text_key, intro_key, supplementary_key, title_url }) => {
    const { t } = useTranslation();
    const onClickURL = (url) => {
        window.open(url, "_blank", "noopener,noreferrer");
    }
    return (
        <div className={styles.page}>
            <Header></Header>
            <TitleText titleTextInfo={{ textKey: title_text_key }}></TitleText>
            <div className={styles.serivce__container}>
                {title_url &&
                    <div className={styles.link__container}>
                        {title_url.map((item, index) => (
                            <div key={index} className={styles.link__list} onClick={() =>{onClickURL(item.url)}}>
                                <div className={styles.list__text__content}>
                                    <span className={styles.list__text}>
                                        {t(item.nameKey)}
                                    </span>
                                    <span className={styles.list__text}>
                                        {item.url}
                                    </span>
                                </div>
                                <div className={styles.list__img__content}>
                                    <img src={item.img_url} className={styles.list__img} alt="storeImage"/>
                                </div>
                            </div>
                        ))}
                    </div>
                }
                {intro_key &&
                    <span className={styles.title__main__text}>
                        {t(intro_key)}
                    </span>
                }
                {elementData.map((item, index) => (
                    <PrivacyPollcyElement key={index} service_info={item} />
                ))}
                {supplementary_key &&
                    <span className={styles.title__text}>
                        {t(supplementary_key)}
                    </span>
                }
            </div>
            <Footer></Footer>
        </div>
    );
}

export default PrivacyPolicyPage;